import React, { useRef, useState } from 'react'
import Attachement from '../../../../Components/Utils/CustomAttrachmentupload';
import SignatureCanvas from 'react-signature-canvas';
import { useToast } from '../../../../Components/Others/ToastServices';
import { BackButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import Plus from '../../../../Components/Icons/Plus';
import DeleteIcon from '../../../../Components/Icons/Delete';

function FireProtect() {
  const toast = useToast();
    const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState(null);

    const [, setCompliance] = useState({
        nfpa: true,
        localCode: true,
        manufacturer: true,
        notes: "",
      });
const location = useLocation();
    const navigate = useNavigate();
      const pageIndex = location.state?.pageIndex;
    const searchQuery = location.state?.searchQuery;
     const [formData, setFormData] = useState({
             facilityName: '',
             facilityAddress: '',
             testType: 'Monthly',
             inspectorCertification: '',
             testDate: '',
             inspectorName: '',
             
             manufacturer: '',
             model: '',
             serialNumber: '',
             fuelType: 'Diesel',
             ratedPower: '',
             ratedVoltage: '',
             ratedFrequency: '',
             
             loadPercentage: '',
             runTime: '',
             oilPressure: '',
             coolantTemp: '',
             batteryVoltage: '',
             fuelLevel: '',
             
             voltageOutput: '',
             frequencyOutput: '',
             issuesFound: '',
             correctiveActions: '',
             nextTestDate: '',
             
             ambientTemperature: '',
             humidity: '',
             weatherConditions: 'Clear',
         
           generalCondition: "Good",
           corrosionPresent: false,
           leaksPresent: false,
           mountingSecure: false,
           ventilationAdequate: false,
         
           fuelLevel: "",
           fuelQuality: "Good",
           fuelFilterCondition: "Good",
           fuelPumpOperation: "Normal",
           fuelLinesSecure: false,
    
            inspectorName: "",
        startDate: "",
        endDate: "",
        totalDays: "",
        persons: "",
        serviceType: [],
        systemType: [],
        observation: "",
        actionTaken:"",
        qty:"",
        desc:"",
        person1:"",
        empcode:"",
        contactNo:"",
        date:"",
        person2:"",
        empcode1:"",
        contactNo1:"",
        date1:"",
           });

           const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCompliance((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
const rows = Array.from({ length: 10 }, (_, i) => i + 1); // 10 rows

 const clientSigCanvas = useRef(null);
  const falconSigCanvas = useRef(null);

  const clearSignature = (type) => {
      if (type === "client" && clientSigCanvas.current) {
        clientSigCanvas.current.clear();
      } else if (type === "falcon" && falconSigCanvas.current) {
        falconSigCanvas.current.clear();
      }
    };
  
    const saveSignature = (type) => {
      if (
        type === "client" &&
        clientSigCanvas.current &&
        !clientSigCanvas.current.isEmpty()
      ) {
        const dataURL = clientSigCanvas.current
          .getTrimmedCanvas()
          .toDataURL("image/png");
        toast.open({
          type: "success",
          message: "Client signature saved locally",
        });
        return dataURL;
      } else if (
        type === "falcon" &&
        falconSigCanvas.current &&
        !falconSigCanvas.current.isEmpty()
      ) {
        const dataURL = falconSigCanvas.current
          .getTrimmedCanvas()
          .toDataURL("image/png");
        toast.open({
          type: "success",
          message: "Falcon signature saved locally",
        });
        return dataURL;
      }
      toast.open({ type: "warning", message: "No signature to save" });
      return null;
    };
    const [image, setImage] = useState([]);
      const [selectedFile, setSelectedFile] = useState(null);

       const handleDeleteConfirm = () => {
        if (deleteInfo) {
            if (deleteInfo.type === "tech") {
                removeTechRow(deleteInfo.index);
            } else if (deleteInfo.type === "damage") {
                removeDamageRow(deleteInfo.index);
            }
        }
        setIsDeletePopupOpen(false);
    };
  
          function handleImageChange(e) {
      const maxFileSize = 200000000; 
      const files = Array.from(e.target.files);
      let fileArr = [];
  
      files.forEach((item) => {
        if (item.size < maxFileSize) {  
          fileArr.push(item);
        } else {
          toast.open({
            type: "warning",
            message: `File Size too big`,
            description: `${item.name} is removed and not uploaded`,
          });
        }
      });
  
      setSelectedFile(fileArr);
  
  
      setImage(fileArr);
      e.target.value = null;
    }
  
    const removeImages = (value) => {
      let List = selectedFile.filter((item) => item?.name !== value?.name);
      setSelectedFile([...List]);
      setImage(List);
    };

    const [damages, setDamages] = useState(
        Array(1).fill().map(() => ({ 
            description: "", 
            quantity: "" 
        }))
    );

    const [tech, setTech] = useState(
        Array(1).fill().map(() => ({ 
            name: "", 
            startdate: "", 
            enddate: "", 
            totalhours: "", 
            noofperson: "" 
        }))
    );

    const addTechRow = () => {
        setTech([...tech, { name: "", startdate: "", enddate: "", totalhours: "", noofperson: "" }]);
    };

    const removeTechRow = (index) => {
        const newTech = tech.filter((_, i) => i !== index);
        setTech(newTech);
    };

     const removeDamageRow = (index) => {
        const newDamages = damages.filter((_, i) => i !== index);
        setDamages(newDamages);
    };

    const handleTechChange = (index, field, value) => {
        const newTech = [...tech];
        newTech[index][field] = value;
        setTech(newTech);
    };

    const addDamageRow = () => {
        setDamages([...damages, { description: "", quantity: "" }]);
    };


    const handleDamageChange = (index, field, value) => {
        const newDamages = [...damages];
        newDamages[index][field] = value;
        setDamages(newDamages);
    };
  

  return (
     <div className="w-full h-full py-2 px-2 sm:px-4">
    <div className="flex justify-between gap-2 sm:gap-0">
        <Breadcrumb
            items={[
                {
                    name: "Forms",
                    link: "/forms/insforms"
                },
                { name: "View" },
            ]}
        />
        <div className="flex gap-2 justify-start sm:justify-end mt-2 sm:mt-0">
            <Link
                to={`/forms/insforms`}
                state={{
                    currentPage: pageIndex,
                    searchQuery: searchQuery != "" ? searchQuery : "",
                }}
            >
                <BackButton link={true} />
            </Link>
        </div>
    </div>

    <div className="bg-white mx-auto mt-4 h-[calc(100vh-145px)] w-full rounded-md flex flex-col overflow-y-auto p-2 sm:p-4 lg:p-6">
        {/* Header Section */}
        <div className="bg-white rounded-lg p-4 sm:p-6 mb-4 shadow-sm border border-gray-200">
            <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-800 mb-2 text-center sm:text-left">
                FIRE PROTECTION SYSTEM
            </h1>
            <h1 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-800 mb-2 text-center sm:text-left">
                FIELD SERVICE REPORT
            </h1>
        </div>

        {/* TECHNICIANS / INSPECTOR DETAILS */}
        <div className="border p-3 sm:p-4 rounded-md mt-3 text-gray-800">
            <h3 className="font-semibold text-lg sm:text-xl mb-3">
                TECHNICIANS / INSPECTOR DETAILS 
            </h3>
            
          <div className="border border-gray-300 rounded-md text-xs sm:text-sm mt-3 overflow-x-auto">
    <table className="w-full border-collapse min-w-[600px]">
        <thead>
            <tr className="text-center font-semibold bg-gray-50">
                <th className="border border-gray-300 p-2">Name</th>
                <th className="border border-gray-300 p-2">Start Date</th>
                <th className="border border-gray-300 p-2">End Date</th>
                <th className="border border-gray-300 p-2">Total Days / Hours</th>
                <th className="border border-gray-300 p-2">No. of Persons</th>
                <th className="border border-gray-300 p-2">
                    <div className="flex gap-2 items-center justify-center">
                        <span>Action</span>
                        <button
                            onClick={addTechRow}
                            type="button"
                            className="p-1 bg-baseColor-primary text-white rounded hover:bg-red-600 transition-colors text-sm"
                        >
                            <Plus size={14} />
                        </button>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            {tech.map((row, index) => (
                <tr key={index} className="text-center hover:bg-gray-50 transition-colors">
                    <td className="border border-gray-300 p-2">
                        <input
                            type="text"
                            className="w-full p-2 sm:p-3 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            value={row.name}
                            onChange={(e) => handleTechChange(index, "name", e.target.value)}
                            placeholder="Name"
                        />
                    </td>
                    <td className="border border-gray-300 p-2">
                        <input
                            type="date"
                            className="w-full p-2 sm:p-3 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            value={row.startdate}
                            onChange={(e) => handleTechChange(index, "startdate", e.target.value)}
                        />
                    </td>
                    <td className="border border-gray-300 p-2">
                        <input
                            type="date"
                            className="w-full p-2 sm:p-3 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            value={row.enddate}
                            onChange={(e) => handleTechChange(index, "enddate", e.target.value)}
                        />
                    </td>
                    <td className="border border-gray-300 p-2">
                        <input
                            type="text"
                            className="w-full p-2 sm:p-3 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            value={row.totalhours}
                            onChange={(e) => handleTechChange(index, "totalhours", e.target.value)}
                            placeholder="Total Days/Hours"
                        />
                    </td>
                    <td className="border border-gray-300 p-2">
                        <input
                            type="number"
                            className="w-full p-2 sm:p-3 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            value={row.noofperson}
                            onChange={(e) => handleTechChange(index, "noofperson", e.target.value)}
                            placeholder="No. of Persons"
                            min="0"
                        />
                    </td>
                    <td className="border border-gray-300 p-2">
                        <div className="flex items-center justify-center">
                            <button
                                onClick={() => {
                                    setDeleteInfo({ index, type: "tech" });
                                    setIsDeletePopupOpen(true);
                                }}
                                type="button"
                                className="text-red-500 cursor-pointer p-1 hover:bg-red-50 rounded transition-colors"
                                title="Delete"
                            >
                                <DeleteIcon color="#dc2626" height={16} />
                            </button>
                        </div>
                    </td>
                </tr>
            ))}
        </tbody>
    </table>
</div>
        </div>

        {/* INSPECTION / SERVICE TYPE */}
        <div className="border p-3 sm:p-4 rounded-md mt-3">
            <h3 className="font-semibold text-lg sm:text-xl text-gray-800 mb-3">
                INSPECTION / SERVICE TYPE
            </h3>
            <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 text-sm text-gray-800">
                {[
                    "Contractual", "Non-Contractual", "Comprehensive", "Semi-Comprehensive",
                    "Non-Comprehensive", "Monthly", "Quarterly", "On Call",
                    "Emergency Call", "Others", "Inspection", "General Service",
                    "Repair Works", "New Installations",
                ].map((item) => (
                    <label key={item} className="flex items-center justify-between gap-2 p-2 border rounded hover:bg-gray-50 transition-colors">
                        <span className="text-xs sm:text-sm">{item}</span>
                        <input
                            type="checkbox"
                            checked={formData.serviceType.includes(item)}
                            onChange={() => handleCheckboxChange("serviceType", item)}
                            className="scale-110"
                        />
                    </label>
                ))}
            </div>
        </div>

        {/* TYPE OF SYSTEMS */}
        <div className="border p-3 sm:p-4 rounded-md mt-3 text-gray-800">
            <h3 className="font-semibold text-lg sm:text-xl mb-3">TYPE OF SYSTEMS</h3>
            <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 text-sm">
                {[
                    "Water Based Sprinkler System", "Foam Based Sprinkler System", "Stand Pipe & Hose System",
                    "Deluge System", "Pre-Action System", "Fire Suppression System",
                    "Fire Alarm System", "Fire Extinguishers", "Aspirating Smoke Detector System",
                    "Emergency & Exit Light System", "Fire Hydrant", "Fire Pump",
                    "Breeching Inlet / FDC", "Voice Evacuation System/PAVA", "Central Battery System", "Others",
                ].map((item) => (
                    <label key={item} className="flex items-center justify-between gap-2 p-2 border rounded hover:bg-gray-50 transition-colors">
                        <span className="text-xs sm:text-sm">{item}</span>
                        <input
                            type="checkbox"
                            checked={formData.systemType.includes(item)}
                            onChange={() => handleCheckboxChange("systemType", item)}
                            className="scale-110"
                        />
                    </label>
                ))}
            </div>
        </div>

        {/* OBSERVATION / CUSTOMER COMPLAINT */}
        <div className="border p-3 sm:p-4 rounded-md mt-3 text-gray-800">
            <h3 className="font-semibold text-lg sm:text-xl mb-3">
                OBSERVATION / CUSTOMER COMPLAINT
            </h3>
            <textarea
                name="observation"
                value={formData.observation}
                onChange={handleInputChange}
                rows={4}
                className="w-full border border-gray-300 rounded p-3 text-sm resize-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                placeholder="Enter observations or complaints here..."
            />
        </div>

        {/* ACTION REQUIRED/TAKEN */}
        <div className="border p-3 sm:p-4 rounded-md text-gray-800 mt-3">
            <h3 className="font-semibold text-lg sm:text-xl mb-3">
                ACTION REQUIRED/TAKEN
            </h3>
            <textarea
                name="actionTaken"
                value={formData.actionTaken}
                onChange={handleInputChange}
                rows={4}
                className="w-full border border-gray-300 rounded p-3 text-sm resize-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                placeholder="Enter here..."
            />
        </div>

        {/* DAMAGES/REPLACEMENT /SPARE PARTS - DETAILS */}
        <div className="mt-5 text-gray-800">
            <h3 className="font-semibold text-lg sm:text-xl mb-3">
                DAMAGES/REPLACEMENT /SPARE PARTS - DETAILS
            </h3>
          <div className="border border-gray-300 text-xs sm:text-sm mt-3 overflow-x-auto rounded">
                            <div className="min-w-[400px]">
                                <div className="grid grid-cols-12 border-b border-gray-300 font-semibold text-center bg-gray-50">
                                    <div className="col-span-1 border-r border-gray-300 p-2">S.No.</div>
                                    <div className="col-span-8 border-r border-gray-300 p-2">Description</div>
                                    <div className="col-span-2 border-r border-gray-300 p-2">Qty</div>
                                    <div className="col-span-1 p-2 flex gap-2 items-center justify-center">
                                        <span>Action</span>
                                        <button
                                            onClick={addDamageRow}
                                            type="button"
                                            className="p-1 bg-baseColor-primary text-white rounded hover:bg-red-600 transition-colors text-sm"
                                        >
                                            <Plus size={14} />
                                        </button>
                                    </div>
                                </div>

                                {damages.map((row, index) => (
                                    <div
                                        key={index}
                                        className="grid grid-cols-12 border-b border-gray-200 last:border-b-0 text-center hover:bg-gray-50 transition-colors"
                                    >
                                        <div className="col-span-1 border-r border-gray-300 p-2 flex items-center justify-center text-sm">
                                            {index + 1}
                                        </div>
                                        <div className="col-span-8 border-r border-gray-300 p-2">
                                            <input
                                                type="text"
                                                className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                                value={row.description}
                                                onChange={(e) => handleDamageChange(index, "description", e.target.value)}
                                                placeholder="Enter description..."
                                            />
                                        </div>
                                        <div className="col-span-2 border-r border-gray-300 p-2">
                                            <input
                                                type="number"
                                                className="w-full p-2 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                                                value={row.quantity}
                                                onChange={(e) => handleDamageChange(index, "quantity", e.target.value)}
                                                placeholder="Qty"
                                                min="0"
                                            />
                                        </div>
                                        <div className="col-span-1 p-2 flex items-center justify-center">
                                            <button
                                                onClick={() => {
                                                    setDeleteInfo({ index, type: "damage" });
                                                    setIsDeletePopupOpen(true);
                                                }}
                                                className="text-red-500 hover:text-red-700 transition-colors p-1"
                                                title="Delete row"
                                            >
                                                <DeleteIcon color="#dc2626" height={16} />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
        </div>

        {/* ACKNOWLEDGEMENT */}
        <div className="border border-gray-300 text-sm mt-5 text-gray-800 overflow-x-auto rounded">
            <div className="min-w-[600px]">
                <div className="border-b border-gray-300 text-gray-800 font-semibold text-lg sm:text-xl text-center bg-gray-50">
                    <div className="p-3 sm:p-4">ACKNOWLEDGEMENT</div>
                </div>

                <div className="grid grid-cols-6 border-b border-gray-300 font-semibold text-center text-gray-800 bg-gray-100">
                    <div className="col-span-1 border-r border-gray-300 p-2 sm:p-3">For</div>
                    <div className="col-span-1 border-r border-gray-300 p-2 sm:p-3">Authorized Person</div>
                    <div className="col-span-1 border-r border-gray-300 p-2 sm:p-3">Employee Code</div>
                    <div className="col-span-1 border-r border-gray-300 p-2 sm:p-3">Contact No.</div>
                    <div className="col-span-1 border-r border-gray-300 p-2 sm:p-3">Date</div>
                    <div className="col-span-1 p-2 sm:p-3">Signature</div>
                </div>

                <div className="grid grid-cols-6 border-b border-gray-300 text-center">
                    <div className="col-span-1 border-r border-gray-300 p-2 sm:p-3 font-medium flex items-center justify-center bg-gray-50">
                        Falcon Fire
                    </div>
                    <div className="col-span-1 border-r border-gray-300 p-2 sm:p-3">
                        <input
                            type="text"
                            name="person1"
                            placeholder="Name"
                            value={formData.person1}
                            onChange={handleInputChange}
                            className="w-full p-2 sm:p-3 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                        />
                    </div>
                    <div className="col-span-1 border-r border-gray-300 p-2 sm:p-3">
                        <input
                            type="text"
                            name="empcode"
                            placeholder="Employee Code"
                            value={formData.empcode}
                            onChange={handleInputChange}
                            className="w-full p-2 sm:p-3 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                        />
                    </div>
                    <div className="col-span-1 border-r border-gray-300 p-2 sm:p-3">
                        <input
                            type="number"
                            name="contactNo"
                            placeholder="Contact No."
                            value={formData.contactNo}
                            onChange={handleInputChange}
                            className="w-full p-2 sm:p-3 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                        />
                    </div>
                    <div className="col-span-1 border-r border-gray-300 p-2 sm:p-3">
                        <input
                            type="date"
                            name="date"
                            value={formData.date}
                            onChange={handleInputChange}
                            className="w-full p-2 sm:p-3 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                        />
                    </div>
                    <div className="col-span-1 p-2 sm:p-3 flex items-center justify-center">
                        <div className="w-12 h-8 border-2 border-dashed border-gray-400 rounded bg-gray-50"></div>
                    </div>
                </div>

                <div className="grid grid-cols-6 text-center">
                    <div className="col-span-1 border-r border-gray-300 p-2 sm:p-3 font-medium flex items-center justify-center bg-gray-50">
                        Client
                    </div>
                    <div className="col-span-1 border-r border-gray-300 p-2 sm:p-3">
                        <input
                            type="text"
                            name="person2"
                            placeholder="Name"
                            value={formData.person2}
                            onChange={handleInputChange}
                            className="w-full p-2 sm:p-3 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                        />
                    </div>
                    <div className="col-span-1 border-r border-gray-300 p-2 sm:p-3">
                        <input
                            type="text"
                            name="empcode1"
                            placeholder="Employee Code"
                            value={formData.empcode1}
                            onChange={handleInputChange}
                            className="w-full p-2 sm:p-3 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                        />
                    </div>
                    <div className="col-span-1 border-r border-gray-300 p-2 sm:p-3">
                        <input
                            type="number"
                            name="contactNo1"
                            placeholder="Contact No."
                            value={formData.contactNo1}
                            onChange={handleInputChange}
                            className="w-full p-2 sm:p-3 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                        />
                    </div>
                    <div className="col-span-1 border-r border-gray-300 p-2 sm:p-3">
                        <input
                            type="date"
                            name="date1"
                            value={formData.date1}
                            onChange={handleInputChange}
                            className="w-full p-2 sm:p-3 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                        />
                    </div>
                    <div className="col-span-1 p-2 sm:p-3 flex items-center justify-center">
                        <div className="w-12 h-8 border-2 border-dashed border-gray-400 rounded bg-gray-50"></div>
                    </div>
                </div>
            </div>
        </div>

        {/* SIGNATURE SECTION */}
        <div className="w-full p-4 sm:p-6">
            <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-4 sm:mb-6">Signature</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
                <div className="relative border border-gray-300 rounded-lg p-4 bg-gray-50">
                    <SignatureCanvas
                        penColor="black"
                        canvasProps={{
                            className: "border border-gray-400 w-full h-32 sm:h-40 rounded-md bg-white",
                        }}
                        ref={falconSigCanvas}
                    />
                    <div className="flex justify-between items-center mt-3">
                        <span className="text-xs font-semibold text-gray-500">
                            Falcon
                        </span>
                        <div className="flex gap-2">
                            <button
                                type="button"
                                onClick={() => clearSignature("falcon")}
                                className="text-xs text-red-600 hover:bg-red-100 px-3 py-1 rounded-md transition"
                            >
                                Clear
                            </button>
                            <button
                                type="button"
                                onClick={() => saveSignature("falcon")}
                                className="text-xs bg-baseColor-primary text-white px-3 py-1 rounded-md hover:bg-red-600 transition"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
                <div className="relative border border-gray-300 rounded-lg p-4 bg-gray-50">
                    <SignatureCanvas
                        penColor="black"
                        canvasProps={{
                            className: "border border-gray-400 w-full h-32 sm:h-40 rounded-md bg-white",
                        }}
                        ref={clientSigCanvas}
                    />
                    <div className="flex justify-between items-center mt-3">
                        <span className="text-xs font-semibold text-gray-500">Client</span>
                        <div className="flex gap-2">
                            <button
                                type="button"
                                onClick={() => clearSignature("client")}
                                className="text-xs text-red-600 hover:bg-red-100 px-3 py-1 rounded-md transition"
                            >
                                Clear
                            </button>
                            <button
                                type="button"
                                onClick={() => saveSignature("client")}
                                className="text-xs bg-baseColor-primary text-white px-3 py-1 rounded-md hover:bg-red-600 transition"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {isDeletePopupOpen && (
                        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
                            <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-auto">
                                <h3 className="text-sm font-medium mb-4">Warning</h3>
                                <p className="mb-6 text-xs">
                                    Are you sure you want to delete this row?
                                </p>
                                <div className="flex justify-end space-x-3">
                                    <button
                                        onClick={() => setIsDeletePopupOpen(false)}
                                        className="px-4 py-[8px] text-xs hover:bg-gray-300 rounded-md bg-[#E6F2F2] text-textColor-main"
                                    >
                                        No
                                    </button>
                                    <button
                                        onClick={handleDeleteConfirm}
                                        className="px-4 py-[8px] text-xs bg-textColor-main rounded-md text-white hover:opacity-90"
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
</div>
  )
}

export default FireProtect
